export default __webpack_public_path__ + "static/media/play.5c0fc3d9.svg";